import React from "react";
import styles from "./InputField.module.css";
import classNames from "classnames";

const cx = classNames.bind(styles);

interface InputFieldProps {
  label: string;
  type: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
}) => {
  const input_classes = cx({
    [styles.input_field]: true,
    [styles.input_field_error]: !!error,
  });

  const label_classes = cx({
    [styles.label]: true,
    [styles.error_text]: !!error,
  });

  return (
    <div
      data-testid={`${name}-input-container`}
      className={styles.input_container}
    >
      <label className={label_classes} htmlFor={name}>
        {label}<span className={styles.required}>*</span>
      </label>
      <input
        className={input_classes}
        data-testid={`${name}-input`}
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {error && (
        <div
          data-testid={`${name}-input-error`}
          className={styles.validation_error}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default InputField;
